<template>
    <div class="bloco margem filtros-container"
        :class="{ 'margem': mostrarFiltros, 'filtros-retraido': !mostrarFiltros }">
        <div class="filtros-header" @click="mostrarFiltros = !mostrarFiltros">
            <h3><i class="bi-funnel"></i> Filtros</h3>
            <i :class="mostrarFiltros ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>
        <div v-show="mostrarFiltros" class="filtros-body">
            <div class="grid-4">
                <div>
                    <label>Projeto</label>
                    <Multiselect v-model="filtrosLocais.projeto" :options="projetosDisponiveis" option-value="id"
                        option-label="nome" placeholder="Todos" :searchable="true" />
                </div>
                <div>
                    <label>Gerente</label>
                    <Multiselect v-model="filtrosLocais.gerente" :options="gerentesDisponiveis" option-value="id"
                        option-label="name" placeholder="Todos" :searchable="true" />
                </div>
                <div>
                    <label>Status</label>
                    <Multiselect v-model="filtrosLocais.status" :options="statusDisponiveis"
                        placeholder="Selecione status" :searchable="true" />
                </div>
                <div>
                    <label>Setor</label>
                    <Multiselect v-model="filtrosLocais.setor" :options="setoresDisponiveis" option-value="id"
                        option-label="nome" placeholder="Todos" :searchable="true" />
                </div>
                <div>
                    <label>Mostrar Projetos a Partir de</label>
                    <input type="date" v-model="filtrosLocais.dataInicioInicial" />
                </div>
            </div>
            <div class="filtros-acoes">
                <button class="acao-secundaria" @click="limparFiltros">Limpar Filtros</button>
                <button @click="aplicarFiltros">Aplicar Filtros</button>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from '@/components/Multiselect.vue';

export default {
    name: 'FiltrosIndicadoresProjetos',
    components: {
        Multiselect
    },
    props: {
        projetosDisponiveis: {
            type: Array,
            default: () => []
        },
        gerentesDisponiveis: {
            type: Array,
            default: () => []
        },
        statusDisponiveis: {
            type: Array,
            default: () => ['Aprovado', 'Concluído', 'Em andamento', 'Proposto', 'suspenso']
        },
        setoresDisponiveis: {
            type: Array,
            default: () => []
        },
        filtros: {
            type: Object,
            default: () => ({
                projeto: [],
                gerente: [],
                status: [],
                setor: [],
                busca: '',
                encerrado: '',
                dataInicioInicial: '',
                dataInicioFinal: '',
                dataTerminoInicial: '',
                dataTerminoFinal: ''
            })
        }
    },
    data() {
        // Inicializa filtros com arrays vazios para campos multiselect
        const camposMultiselect = ['projeto', 'gerente', 'status', 'setor']
        const filtrosInicializados = { ...this.filtros }
        camposMultiselect.forEach(campo => {
            if (!filtrosInicializados[campo] || !Array.isArray(filtrosInicializados[campo])) {
                filtrosInicializados[campo] = []
            }
        })

        // Define dtInicioIni como 01 de janeiro do ano atual se estiver vazio
        if (!filtrosInicializados.dataInicioInicial) {
            const anoAtual = new Date().getFullYear();
            filtrosInicializados.dataInicioInicial = `${anoAtual}-01-01`;
        }

        // Define status como "Em andamento" se estiver vazio (sempre disponível na lista fixa)
        if (!filtrosInicializados.status || filtrosInicializados.status.length === 0) {
            filtrosInicializados.status = ['Em andamento'];
        }

        return {
            mostrarFiltros: false,
            filtrosLocais: filtrosInicializados
        };
    },
    watch: {
        filtros: {
            handler(newVal) {
                // Normaliza filtros para arrays
                const filtrosConvertidos = { ...newVal }

                // Garante que os campos multiselect sejam arrays
                const camposMultiselect = ['projeto', 'gerente', 'status', 'setor']
                camposMultiselect.forEach(campo => {
                    if (!filtrosConvertidos[campo] || !Array.isArray(filtrosConvertidos[campo])) {
                        filtrosConvertidos[campo] = []
                    } else {
                        // Converte objetos para IDs quando necessário (exceto status que já é string)
                        if (campo !== 'status' && filtrosConvertidos[campo].length > 0 && typeof filtrosConvertidos[campo][0] === 'object') {
                            filtrosConvertidos[campo] = filtrosConvertidos[campo].map(item => item.id || item)
                        }
                    }
                })

                // Não força status padrão aqui - permite que seja vazio para buscar todos

                this.filtrosLocais = filtrosConvertidos
            },
            deep: true
        },
    },
    methods: {
        aplicarFiltros() {
            // Os filtros já estão no formato correto (arrays de IDs/strings)
            const filtrosNormalizados = { ...this.filtrosLocais }

            // Garante que os campos multiselect sejam arrays
            const camposMultiselect = ['projeto', 'gerente', 'status', 'setor']
            camposMultiselect.forEach(campo => {
                if (!filtrosNormalizados[campo] || !Array.isArray(filtrosNormalizados[campo])) {
                    filtrosNormalizados[campo] = []
                }
            })

            this.$emit('aplicar-filtros', filtrosNormalizados)
        },
        limparFiltros() {
            // Define dtInicioIni como 01 de janeiro do ano atual
            const anoAtual = new Date().getFullYear();
            const dataInicioInicialPadrao = `${anoAtual}-01-01`;

            this.filtrosLocais = {
                projeto: [],
                gerente: [],
                status: ['Em andamento'],
                setor: [],
                busca: '',
                encerrado: '',
                dataInicioInicial: dataInicioInicialPadrao,
                dataInicioFinal: '',
                dataTerminoInicial: '',
                dataTerminoFinal: ''
            };
            this.$emit('limpar-filtros');
        }
    }
};
</script>

<style scoped>
.filtros-container {
    margin-bottom: 1rem;
    position: relative;
    overflow: visible;
}

.filtros-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 0.5rem 0;
}

.filtros-header h3 {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
}

.filtros-header i:last-child {
    font-size: 1.2rem;
    transition: transform 0.2s ease;
}

.filtros-body {
    padding: 1rem;
    border-top: 1px solid var(--cor-separador);
    position: relative;
    overflow: visible;
}

.filtros-body .grid-4 {
    margin-bottom: 1rem;
}

.filtros-acoes {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid var(--cor-separador);
}

.grid-4>div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    position: relative;
    overflow: visible;
}

.grid-4 label {
    font-weight: 600;
    color: var(--cor-fonte-secundaria, #555);
    font-size: 0.9rem;
}

.grid-4 input[type="text"],
.grid-4 input[type="date"],
.grid-4 select {
    padding: 0.35rem 0.5rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    font-size: 0.9rem;
    color: #333;
    width: 100%;
    box-sizing: border-box;
}

.alinha-v {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
</style>
